import type { FunctionComponent } from 'react';

import dayjs from 'dayjs';
import { Card, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'i18n';

import { formatTime } from 'helpers/format';
import { isStoreClosedHelper } from 'helpers/menuManagementHours';
import type { MenuSpecialHour } from 'types/menuHours';

const NS = 'hoursModal';

type HolidayHoursCardProps = {
  specialHours: MenuSpecialHour[];
};

export const HolidayHoursCard: FunctionComponent<HolidayHoursCardProps> = ({ specialHours }) => {
  const { t } = useTranslation(NS);

  return (
    <Card data-testid="holidayHoursCard" bg="var(--surface-secondary)">
      <Text variant="body-sm-bold" mb="xs2">
        {t('HolidayHoursCard.holidayHours')}
      </Text>
      <Stack gap="xs2">
        {specialHours.map(hour => (
          <Group key={`${hour.appliedDate}-${hour.startTime}`} align="flex-start">
            <Text variant="sublabel-sm" w="var(--dimension-xl6)" flex="0 0 auto">
              {/* Slashes keep dayjs from parsing the date as UTC and shifting it a day back */}
              {dayjs(hour.appliedDate.replace(/-/g, '/')).format('MMM D, YYYY')}
            </Text>
            <Text variant="sublabel-sm" style={{ whiteSpace: 'nowrap' }}>
              {isStoreClosedHelper(hour)
                ? t('HolidayHoursCard.closed')
                : `${formatTime(hour.startTime)} – ${formatTime(hour.endTime)}`}
            </Text>
          </Group>
        ))}
      </Stack>
    </Card>
  );
};
